import axios from 'axios';
import React, { useState, useEffect } from "react";

import AdminSideBar from './Admin-SideBar';
import PreviousAppointments from '../Doctor UI/PreviousAppointments';
import {  useLocation, Link } from 'react-router-dom';
import { API_DETAILS } from '../../App';
import Loader from '../../utils/loader';
import { formatDate } from '../../utils/formatDate';

const AdminViewPatientProfile = () => {

    const [prevAppts, setPrevAppts] = useState([]);
    const [upComingAppts, setUpcomingAppts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [providerInfo, setProviderInfo] = useState(null);
    const location = useLocation();


    useEffect(() => {
        // The record arrives in router state from the list page, so a refresh or a
        // pasted link has nothing to show. That used to throw and leave a blank
        // screen; now the page says so.
        if (!location.state) {
            setIsLoading(false);
            return;
        }

        const temp = {
            userId: location.state.userId,
            firstName: location.state.firstName,
            lastName: location.state.lastName,
            email: location.state.email,
            phone1: location.state.phone1,
            address: location.state.address,
            city: location.state.city,
            createdAt: location.state.createdAt,
            zipCode: location.state.zipCode,
            specialty: location.state.specialty,
            status: location.state.status,
            userType: location.state.userType,
            state: location.state.state,
            profileImageURL: location.state.profileImageURL,
            license: location.state.license,
            username: location.state.username,
            gender: location.state.gender,
            dateOfBirth: location.state.dateOfBirth
        };
        setProviderInfo(temp);
        fetchPrevAndUpcomingAppointments();
    }, []);


    const fetchPrevAndUpcomingAppointments = async () => {
        const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/appointments/${location.state.userId}?timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        try {
            const res = await axios.get(url, config);
            setPrevAppts(res.data.previousAppointments);
            setUpcomingAppts(res.data.upComingAppointments);
            setIsLoading(false);
        }
        catch (err) {
            setIsLoading(false);
        }
    }


    // Renders the appointments it is given. It used to copy them into its own
    // state on mount — but being declared inside the page component it was
    // remounted on every render, and as a nested component with an empty
    // dependency list it also never picked up appointments that arrived later.
    const TodayAppointmentList = () => {
        return (
            <div>
                {(upComingAppts || []).map((item) => (
                    <div className='previous-appointment' key={item.id}>
                        <div>
                            <h3 >{String(item.time || '').split(',')[0]}, {item.patientstime} - {item.name}</h3>
                        </div>
                        <ul>
                            <li>Date : {item.time}</li>
                            <li>Time : {item.patientstime}</li>
                            <li>Diagnosis: {item.diagnosisname}</li>
                            <li>Symptom score: {item.symptomscore}</li>
                            <li>Meet-type: {item.meetup}</li>
                            {/* <p>{item.meetup}</p> */}
                        </ul>
                    </div>
                ))}
            </div>
        );
    };


    if (!location.state) {
        return (
            <div>
                <div className='hm'>
                    <div className='sidebar'>
                        <AdminSideBar data={'admin-patients'} />
                    </div>
                    <div className="admin-view-doctor-container" style={{ width: '100%', padding: '24px' }}>
                        <h2>We couldn't load this patient</h2>
                        <p>Open a patient from the list to see their profile.</p>
                        <Link to="/admin-patients">Back to patients</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className='hm'>
                <div className='sidebar'>
                    <AdminSideBar data={'admin-patients'} />
                </div>
                <div className="admin-view-doctor-container" style={{ width: '100%' }}>
                    <div className='admin-view-doctor-header'>
                        <div className='header'>
                            <h1 style={{ marginLeft: '15px' }}>Youro</h1>
                        </div>
                    </div>
                    <div className='admin-view-doctor-body'>
                        <Loader active={isLoading} />
                        {
                            !isLoading && <>
                                <div className='all-plans-patient'>
                                    <div className='admin-details-view'>
                                        <h2>Upcoming Appointments</h2>
                                        {TodayAppointmentList()}</div>
                                    <div className='admin-details-view'>
                                        <h2>Previous Appointments</h2>
                                        <PreviousAppointments data={prevAppts} />
                                    </div>
                                    <div className='admin-details-view'>

                                        <img style={{ margin: '15px auto 30px auto', borderRadius: '5px', display: 'block' }} src={ require("../../assets/Display_icon.png") } alt="Preview" width="150" height="150" />
                                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <div style={{ width: '35%' }}>
                                                <p>First Name:</p>
                                                <p>Last Name:</p>
                                                <p>Email</p>
                                                <p>Mobile Number:</p><br />
                                                <p>License Number:</p><br />
                                                <p>Gender:</p>
                                                <p>Date of Birth:</p>
                                                <p>Address: </p>
                                                <p>Signed Up:</p>

                                            </div>
                                            <div style={{ width: '60%' }}>
                                                <p><strong>{providerInfo.firstName}</strong></p>
                                                <p><strong>{providerInfo.lastName}</strong></p>
                                                <p><strong>{providerInfo.email}</strong></p>
                                                <p><strong>{providerInfo.phone1}</strong></p>
                                                <p><strong>{providerInfo.license}</strong></p>
                                                <p><strong>{providerInfo.gender}</strong></p>
                                                <p><strong>{formatDate(providerInfo.dateOfBirth)}</strong></p>
                                                <p><strong>
                                                    {[providerInfo.address, providerInfo.city,
                                                      [providerInfo.state, providerInfo.zipCode].filter(Boolean).join(' ')]
                                                        .filter(Boolean).join(', ') || '—'}
                                                </strong></p>
                                                {/* The console could not say when anyone joined. Accounts
                                                    older than the created_at column have no date to show. */}
                                                <p><strong>{
                                                    providerInfo.createdAt
                                                        ? new Date(providerInfo.createdAt).toLocaleString('en-US', {
                                                            year: 'numeric', month: 'short', day: 'numeric',
                                                            hour: 'numeric', minute: '2-digit',
                                                        })
                                                        : 'Not recorded'
                                                }</strong></p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>

        </div>
    );

};

export default AdminViewPatientProfile;
